// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shared-screen-surface video {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.shared-screen-surface-controls {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  position: absolute;
  align-items: center;
  background-color: var(--dark-blue-background-color);
  color: var(--text-contrast-color);
  padding: var(--input-element-gap-small) var(--input-element-gap);
  border-bottom-left-radius: var(--dialog-border-radius);
  border-bottom-right-radius: var(--dialog-border-radius);

  > span {
    font-size: var(--font-size-m);
    margin-left: 3px;
  }

  > button {
    color: var(--text-contrast-color);
  }
}

.shared-screen-surface-spacer {
  height: var(--input-element-height-small);
  width: 2px;
  background-color: var(--text-contrast-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/shared-screen-surface/SharedScreenSurface.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;EACnD,iCAAiC;EACjC,gEAAgE;EAChE,sDAAsD;EACtD,uDAAuD;;EAEvD;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,4CAA4C;AAC9C","sourcesContent":[".shared-screen-surface video {\n  max-width: 100%;\n  max-height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.shared-screen-surface-controls {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  position: absolute;\n  align-items: center;\n  background-color: var(--dark-blue-background-color);\n  color: var(--text-contrast-color);\n  padding: var(--input-element-gap-small) var(--input-element-gap);\n  border-bottom-left-radius: var(--dialog-border-radius);\n  border-bottom-right-radius: var(--dialog-border-radius);\n\n  > span {\n    font-size: var(--font-size-m);\n    margin-left: 3px;\n  }\n\n  > button {\n    color: var(--text-contrast-color);\n  }\n}\n\n.shared-screen-surface-spacer {\n  height: var(--input-element-height-small);\n  width: 2px;\n  background-color: var(--text-contrast-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
